import { render } from "./ContentBuilderEditor.vue?vue&type=template&id=7bb2391e"
import script from "./ContentBuilderEditor.vue?vue&type=script&lang=js"
export * from "./ContentBuilderEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__